import React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { SNACKBAR_POSITION } from "../../constants/orderFormConstants";

const Alert = React.forwardRef((props, ref) => {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const OrderSnackbar = ({ openSuccess, openError, handleClick }) => {
  const { vertical, horizontal } = SNACKBAR_POSITION;

  return (
    <Stack spacing={2} sx={{ width: "5%" }}>
      <Snackbar
        open={openSuccess}
        autoHideDuration={6000}
        onClose={handleClick}
        anchorOrigin={{ vertical, horizontal }}
        key="success-snackbar"
      >
        <Alert
          onClose={handleClick}
          severity="success"
          sx={{ width: "100%" }}
        >
          Order created successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={handleClick}
        anchorOrigin={{ vertical, horizontal }}
        key="error-snackbar"
      >
        <Alert onClose={handleClick} severity="error" sx={{ width: "100%" }}>
          Error creating order.
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default OrderSnackbar;
